(()=>{
 'use strict';
 const button=document.querySelector('.av-whatsapp-context');
 if(!button)return;
 const selectors=['.av-product-purchase-summary','.product-form__buttons','.product-form__submit','.av-dock','#cart-icon-bubble','.cart__checkout-button','[name="checkout"]'];
 let queued=false;
 function place(){
  queued=false;button.style.transform='';button.style.visibility='';
  const base=button.getBoundingClientRect(),width=document.documentElement.clientWidth,height=window.innerHeight;
  const header=document.querySelector('.av-header')?.getBoundingClientRect();
  const top=Math.max(12,header&&header.bottom>0?header.bottom+8:12);
  const positions=[[base.left,base.top],[12,base.top],[base.left,top],[12,top]];
  const rects=selectors.flatMap(s=>Array.from(document.querySelectorAll(s))).map(e=>e.getBoundingClientRect()).filter(r=>r.width>0&&r.height>0&&r.bottom>0&&r.top<height&&r.right>0&&r.left<width);
  const safe=positions.find(([x,y])=>x>=0&&y>=0&&x+base.width<=width&&y+base.height<=height&&rects.every(r=>x+base.width<=r.left||x>=r.right||y+base.height<=r.top||y>=r.bottom));
  if(!safe){button.style.visibility='hidden';return;}
  button.style.transform='translate('+(safe[0]-base.left)+'px,'+(safe[1]-base.top)+'px)';
 }
 function schedule(){if(!queued){queued=true;requestAnimationFrame(place);}}
 window.addEventListener('scroll',schedule,{passive:true});
 window.addEventListener('resize',schedule,{passive:true});
 document.addEventListener('change',schedule);
 place();
})();
